import React from 'react';

import {
  Box,
  FieldGroup,
  Form,
  InputField,
  Modal,
  useWindowSize,
  Typography,
} from 'vindi-ds-components';

import { PrMinusSquare, PrPlusSquare } from 'vindi-ds-icons/pr';

import tokens from 'vindi-ds-tokens';

const ModalExport = ({ modalRef }) => {
  const initialValues = {
    export: '',
    format: '',
    bill: [],
    subscription: [],
    periodExport: [],
    metadataExport: [],
    invoiceExport: [],
  };

  const { isMobile } = useWindowSize();

  const [advancedOptionsOpen, setAdvancedOptionsOpen] = React.useState(false);

  const handleClickClearFilters = ({ setValues }) => {
    setValues(initialValues);
  };

  const handleSubmit = () => modalRef.current.close();

  const handleClickAdvancedOptions = () => setAdvancedOptionsOpen(
    (currentAdvancedOptionsOpen) => !currentAdvancedOptionsOpen,
  );

  const LabelBold = ({ label }) => (
    <Typography variant='body1' color='textPrimary' weight='bold'>
      {label}
    </Typography>
  );

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      id='formExport'
    >
      {(formProps) => (
        <Modal
          ref={modalRef}
          title='Exportar'
          btnPrimaryLabel='Exportar'
          btnPrimaryProps={{ form: 'formExport', type: 'submit' }}
          btnSecondaryLabel='Limpar filtro'
          btnSecondaryClick={() => handleClickClearFilters(formProps)}
          scrollMode={isMobile ? 'page' : 'modal'}
        >
          <>
            <Box mb={3}>
              <Box mb={1}>
                <Typography variant='subtitle2' color='textPrimary'>Exportar</Typography>
              </Box>

              <FieldGroup name='export' radio>
                <InputField label='Apenas página atual' value='firstPage' id='firstPage' />
                <InputField label='Todas as páginas' value='allPages' id='allPages' />
              </FieldGroup>
            </Box>

            <Box mb={4}>
              <Box mb={1}>
                <Typography variant='subtitle2' color='textPrimary'>Formato</Typography>
              </Box>

              <FieldGroup name='format' radio>
                <InputField label='CSV Simples' value='csv' id='csv' />
                <InputField label='Excel' value='excel' id='excel' />
              </FieldGroup>
            </Box>

            <Box
              display='flex'
              alignItems='center'
              color={tokens.color.brand.secondary[500].value}
              mb={4}
              style={{ cursor: 'pointer' }}
              onClick={handleClickAdvancedOptions}
            >
              <Box display='flex' alignItems='center' mr={1}>
                {advancedOptionsOpen ? (
                  <PrMinusSquare color='inherit' />
                ) : (
                  <PrPlusSquare color='inherit' />
                )}
              </Box>

              <Typography variant='body2' color='inherit'> Opções avançadas </Typography>
            </Box>

            {advancedOptionsOpen ? (
              <Box>
                <Box mb={2}>
                  <Typography variant='subtitle2' color='textPrimary'>
                    Entidades
                  </Typography>
                </Box>

                <Box mb={1}>
                  <Box mb={1}>
                    <Typography variant='body1' color='textPrimary' weight='bold'>
                      Fatura
                    </Typography>
                  </Box>

                  <FieldGroup name='bill' checkbox>
                    <InputField
                      label='Método de pagamento'
                      value='paymentMethod'
                      id='billPaymentMethod'
                    />
                    <InputField
                      label='Produto'
                      value='product'
                      id='billProduct'
                    />
                    <InputField
                      label='Cobrança'
                      value='charge'
                      id='billCharge'
                    />
                    <InputField
                      label='Cliente'
                      value='client'
                      id='billClient'
                    />
                  </FieldGroup>
                </Box>

                <Box mb={1}>
                  <Box mb={1}>
                    <Typography variant='body1' color='textPrimary' weight='bold'>
                      Assinatura
                    </Typography>
                  </Box>

                  <FieldGroup name='subscription' checkbox>
                    <InputField
                      label='Assinatura'
                      value='subscription'
                      id='subscription'
                    />
                    <InputField
                      label='Cliente'
                      value='client'
                      id='subscriptionClient'
                    />
                    <InputField
                      label='Plano'
                      value='plan'
                      id='subscriptionPlan'
                    />
                    <InputField
                      label='Método de pagamento'
                      value='paymentMethod'
                      id='subscriptionPaymentMethod'
                    />
                    <InputField
                      label='Produto'
                      value='product'
                      id='subscriptionProduct'
                    />
                  </FieldGroup>

                </Box>

                <InputField
                  label={<LabelBold label='Período' />}
                  name='periodExport'
                  value='period'
                  id='periodExport'
                  checkbox
                />

                <InputField
                  label={<LabelBold label='Metadado' />}
                  name='metadataExport'
                  value='metadata'
                  id='metadataExport'
                  checkbox
                />

                <InputField
                  label={<LabelBold label='Nota fiscal' />}
                  name='invoiceExport'
                  value='invoice'
                  id='invoiceExport'
                  checkbox
                />
              </Box>
            ) : null}

            <Typography>
              Entidades com possibilidade de conter mais de um item serão exportadas
              em linhas separadas
            </Typography>
          </>
        </Modal>
      )}
    </Form>
  );
};

export default ModalExport;
